<template>
    <div class="reference" id="reference">
      <h2 class="theme-background" v-if="ARTICLE.reflist.title && ARTICLE.reflist.title.length > 0">
        <component :is="'jo' + item.name" v-for="item in this.ARTICLE.reflist.title" v-bind:key="item.index" v-bind:data="item.data"></component>
      </h2>
      <h2 class="theme-background" v-else>{{ARTICLE.defaultlang=='zh'?'参考文献':'References'}}</h2>
      <div class="jom-item" v-if="item.citation.length>0" v-for="item in reflist" :key="item.id">
          <span class="reference-label">{{ item.label }}</span>
          <p v-for="( cite , index ) in item.citation" :key="index">
              <!--{{ cite.text }}-->
            <component :is="'jo' + item2.name" v-for="item2 in cite.text" v-bind:key="item2.index" v-bind:data="item2.data"></component>
            <span style="white-space: nowrap" v-if="showLink">
                [<a class="jo-refer-origin" :href="'https://xueshu.baidu.com/s?wd='+setTitle(cite)+'&site=xueshu_se'" target="_blank"
            >{{ARTICLE.defaultlang=='zh'?'百度学术':'Baidu Scholar'}}</a>]&nbsp;
                <!--[<a class="jo-refer-origin" :href="'https://scholar.google.com/scholar_lookup?author='+setAuthor(cite.text)+'&title='+setTitle(cite)" target="_blank">Google Scholar</a>]-->
              </span>
          </p>
      </div>
    </div>
</template>

<script>
    import joinlineformula from '../formula/inlineformula.vue'
    export default {
        components: {
          joinlineformula
        },
        data() {
            return {
                height: 0,
                reflist: []
            }
        },
        mounted() {
            this.height = this.GLOBAL.topbarheight
        },
        created() {
            this.reflist = this.ARTICLE.reflist.data
        },
      methods:{
        setTitle(citation){
          let title = '';
          if (citation.title && citation.title!==''){
            title = citation.title;
          }else {
            for (let i in citation.text){
              title = title + citation.text[i].data;
            }
          }
          return title;
        },
        setAuthor(cite){
          for (let i in cite){
            if (cite[i].name === 'text' && cite[i].data !== ''){
              return cite[i].data
            }
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
    .jom-item{
        margin-bottom:20px;
        .reference-label{
            float: left;
            width: 18px;
            padding-right: 3px;
            font-size: 1.2rem;
            text-align: right;
            font-weight: bold;
            line-height: 24px;
        }
        p{
            text-indent: 0em;
            padding-left: 30px;
            margin: 0px;
          p{
            padding-left: 0;
          }
        }
    }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/reference/reference.vue